import React from 'react'

import './Button.css'

interface ButtonProps {
	id?: string
	children: React.ReactNode
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
	disabled?: boolean
	/** Show a spinner and refuse further clicks while the action is in flight. */
	loading?: boolean
}

// A real <button>, not a clickable <div>: iOS Safari does not dispatch click on
// non-interactive elements, so taps on the submit buttons did nothing on iPad
// while working everywhere else. It also makes the buttons keyboard-reachable.
// `type='button'` keeps the ones inside a <form> from submitting it natively —
// the connection form drives its own submit through requestSubmit().
function Button(props: ButtonProps) {
	// Disabling while loading is what stops a double submit: the actions behind
	// these buttons create forms and send emails, so a second click costs a
	// duplicate.
	const disabled = props.disabled === true || props.loading === true

	return (
		<button
			type='button'
			id={props.id}
			className='button'
			onClick={props.onClick}
			disabled={disabled}
			aria-busy={props.loading === true}
		>
			{props.loading === true && <span className='buttonSpinner' aria-hidden='true' />}
			{props.children}
		</button>
	)
}

export default Button
